import { useSoyuzData } from '@spotahome/soyuz/client';
import {
  ThemeProvider,
  FooterSimplified,
  UserInfoProvider,
  DeviceProvider
} from '@spotahome/ui-library';

import '@spotahome/landings-common/src/scss/init.scss';

import './main.scss';
import ReferAFriend from './components/ReferAFriend';
import ReferAFriendRevamp from './components/ReferAFriendRevamp';

const ReferAFriendContainer = () => {
  const { [ReferAFriendContainer.NAME]: requestedData } = useSoyuzData();

  const { asWebView, deviceType } = requestedData;
  const isRevaptRedesign = deviceType === 'desktop';

  return (
    <ThemeProvider flags={{ newButtons: true }}>
      <DeviceProvider deviceType={deviceType}>
        <UserInfoProvider>
          {isRevaptRedesign ? <ReferAFriendRevamp /> : <ReferAFriend />}
          {!asWebView && <FooterSimplified />}
        </UserInfoProvider>
      </DeviceProvider>
    </ThemeProvider>
  );
};

ReferAFriendContainer.NAME = 'ReferAFriend';

ReferAFriendContainer.requestData = req => ({
  data: {
    asWebView: req.query.as === 'web-view',
    deviceType: req.device.type
  }
});

export default ReferAFriendContainer;
